import { DefaultQueryBuilder } from "@/core/api/DefaultQueryBuilder";
import { QueryBuilderFactory } from "@/core/api/QueryBuilder";

export function createQueryBuilderFactory(): QueryBuilderFactory {
  return {
    create: () => new DefaultQueryBuilder(),
  };
}
